import { render, staticRenderFns } from "./OrderDetail.vue?vue&type=template&id=c509999e&scoped=true&"
import script from "./OrderDetail.vue?vue&type=script&lang=js&"
export * from "./OrderDetail.vue?vue&type=script&lang=js&"
import style0 from "./OrderDetail.vue?vue&type=style&index=0&id=c509999e&prod&lang=scss&scoped=true&"
import style1 from "./OrderDetail.vue?vue&type=style&index=1&id=c509999e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c509999e",
  null
  
)

export default component.exports